import {defineCustomElement} from 'extensions/ui-utils';
import IMask from 'imask';
import {html, LitElement} from 'lit';

export class InputMaskComponent extends LitElement {
	static get properties () {
		return {
			mask: {
				type: String
			},
			placeholderCharacter: {
				attribute: 'placeholder-character',
				type: String
			},
			value: {
				type: String
			}
		};
	}

	/**
	 * @type {Element | undefined}
	 */
	get input () {
		for (let child of this.children) {
			if (child.nodeName === 'INPUT') {
				return child;
			}
		}

		return void 0;
	}

	constructor () {
		super();

		/**
		 * @type {string}
		 */
		this.mask = '';

		/**
		 * @type {string}
		 */
		this.placeholderCharacter = '_';

		/**
		 * @type {string}
		 */
		this.value = '';
	}

	connectedCallback () {
		super.connectedCallback();

		// eslint-disable-next-line new-cap
		this.instance = IMask(this.input, {
			lazy: false,
			mask: this.mask,
			placeholderChar: this.placeholderCharacter
		});
	}

	disconnectedCallback () {
		this.instance.destroy();

		super.disconnectedCallback();
	}

	/**
	 * @param {Map<string, any>} changedProperties
	 */
	updated (changedProperties) {
		if (changedProperties.has('value')) {
			this.instance.value = this.value;
		}
	}

	render () {
		return html`<slot></slot>`;
	}
};

defineCustomElement('x-input-mask', InputMaskComponent);
